// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

export const MONTHS_IN_YEAR = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

// ── Formatters ────────────────────────────────────────────────────
export function formatDate(dateString) {
  if (!dateString) return '—';
  const d = new Date(dateString);
  return d.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatMonthYear(year, month) {
  return `${MONTHS_IN_YEAR[month - 1]} ${year}`;
}

// ── Current values ────────────────────────────────────────────────
export const currentYear = () => new Date().getFullYear();
export const currentMonth = () => new Date().getMonth() + 1;
export const currentDay = () => new Date().getDate();

export const daysInMonth = (year, month) => new Date(year, month, 0).getDate();

// ── Comparison (used by chart sorting) ───────────────────────────
export const compareMonths = (a, b) =>
  MONTHS_IN_YEAR.indexOf(a.date) - MONTHS_IN_YEAR.indexOf(b.date);

// ── Zero-pad helper ───────────────────────────────────────────────
export const pad2 = (n) => String(n).padStart(2, '0');

// ── Legacy compat — used by components that import dateService ────
export const dateService = {
  formatDateValue: formatDate,
  currentYear,
  currentMonth,
  currentDay,
  numberOfDaysInCurrentMonth: () => daysInMonth(currentYear(), currentMonth()),
  compareMonths,
  formatNumberValue: (n, digits) =>
    n.toLocaleString('en-US', {
      minimumIntegerDigits: digits,
      useGrouping: false,
    }),
};

export function getMonthRange(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const days = daysInMonth(year, date.getMonth() + 1);
  return {
    start: `${year}-${month}-01`,
    end: `${year}-${month}-${days}`,
  };
}

// { start, end } for a given year, or a single month within it (1-indexed).
// Used to turn a year/month picker into date_from/date_to report params.
export function getYearOrMonthRange(year, month) {
  if (!month) {
    return { start: `${year}-01-01`, end: `${year}-12-31` };
  }
  const m = pad2(month);
  return {
    start: `${year}-${m}-01`,
    end: `${year}-${m}-${pad2(daysInMonth(year, month))}`,
  };
}
